import React from "react";
import PropTypes from "prop-types";

import FormSelect from "../FormUi/FormSelect";
import Select from "./Select";
import moment from "moment";
import Attachment from "../Attachment";


const Error = ({ message }) =>
  message ? <div className="has-error"><span className="help-block">{message}</span></div> : null;

class InServiceForm extends React.Component {
  account = window.Application.currentAccount
  refStartTime = null;
  refEndTime = null;

  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: props.location || "",
      timeVerificationError: null
    };
  }

  componentDidMount() {
    const { startTime, endTime } = this.props;

    $(this.refStartTime).kendoDateTimePicker({
      change: this.handleChangeStartTime,
      value: startTime ? moment(startTime).toDate() : moment('12:00 pm', 'hh:mm a').toDate()
    });

    $(this.refEndTime).kendoDateTimePicker({
      change: this.handleChangeEndTime,
      value: endTime ? moment(endTime).toDate() : moment('01:00 pm', 'hh:mm a').toDate()
    });

    this.verifyTimes();
  }

  verifyTimes = () => {
    const startTimeWidget = $(this.refStartTime);
    const endTimeWidget = $(this.refEndTime);
    if (!startTimeWidget.val() || !endTimeWidget.val()) {
      this.props.toggleSaveDisabled(true);
      return;
    }

    if (moment(startTimeWidget.val()).isSameOrAfter(moment(endTimeWidget.val()))) {
      this.setState({ saveDisabled: true, timeVerificationError: 'Please verify start time is before end time' });
      this.props.toggleSaveDisabled(true);
    } else {
      this.setState({ saveDisabled: false, timeVerificationError: null });
      this.props.toggleSaveDisabled(false);
    }
  }

  handleChangeStartTime = e => {
    const { onChange } = this.props;
    const newStartTime = moment(e.sender.value());
    const endTimeWidget = $(this.refEndTime);
    const newEndTime = moment(`${newStartTime.format('YYYY/M/D')} ${moment(endTimeWidget.val()).format('LT')}`);
    endTimeWidget.data("kendoDateTimePicker").value(newEndTime.toDate());
    this.verifyTimes();
    
    onChange({
      target: {
        name: "startTime",
        value: newStartTime
      }
    });
    onChange({
      target: {
        name: "endTime",
        value: newEndTime
      }
    });
  };

  handleChangeEndTime = e => {
    const { onChange } = this.props;
    this.verifyTimes();

    onChange({
      target: {
        name: "endTime",
        value: moment(e.sender.value())
      }
    });
  };

  handleLocationChange = (e) => {
    const { onChange } = this.props;
    const selectedLocation = e.target.value;
    this.setState({ selectedLocation });
    onChange(e);
  };

  employeeUrl = () => {
    let url = "/api/v1/employees.json?search={q}&method=full_name&active=true&archived=false&in_service_access=in_service_admin_access&order_by=first_name"
    if (this.state.selectedLocation && this.state.selectedLocation != -1) {
      url += `&location_ids=${this.state.selectedLocation}`
    }

    return url
  }

  render() {
    const {
      errors,
      categories,
      instructors,
      defInstructors,
      locations,
      topic,
      location,
      selectedCategories,
      allowSignUps,
      classLimit,
      notes,
      generalFiles,
      instructorsFiles,
      status,
      onChange,
      onChangeInstructors,
      onChangeCategories,
      onChangeAllowSignUps,
      onAddAttachments,
      onDeleteAttachment
    } = this.props;

    return (
      <div>
        <div>
          <label htmlFor="inservice-location">Location</label>
          <Select
            inputId={"inservice-location"}
            selectTitle={"select location"}
            selectProps={{ name: "location" }}
            options={locations}
            value={location}
            onChange={this.handleLocationChange}
          />
             {(location === "" && this.account.scheduling_toggle)&&(
            <p className="pink-text">
              Shifts will not be synced to schedule unless a location is chosen
            </p>
          )}
        </div>

        <div className="mb-15">
          <label htmlFor="inservices-add-start-time">Start Time</label>
          <input
            ref={r => this.refStartTime = r}
            className="full-width"
            id="inservices-add-start-time"
          />
          <Error message={errors.start_time} />
        </div>

        <div className="mb-15">
          <label htmlFor="inservices-add-end-time">End Time</label>
          <input
            ref={r => this.refEndTime = r}
            className="full-width"
            id="inservices-add-end-time"
          />
          <Error message={errors.end_time} />
        </div>
        <Error message={this.state.timeVerificationError} />

        <div>
          <label htmlFor="inservice-topic">Topic</label>
          <input
            id="inservice-topic"
            className="form-control"
            name="topic"
            value={topic}
            onChange={onChange}
          />
        </div>

        <div className="mb-15">
          <label htmlFor="inservices-add-categories">Categories</label>
          <FormSelect
            _key="id"
            _val="name"
            selectId={"inservices-add-categories"}
            name="categories"
            urlSearch="/in_services/categories.json?q={q}"
            dataValue={selectedCategories}
            options={categories}
            selectProps={{ isMulti: true }}
            errors={errors.in_service_category_in_services}
            onChange={onChangeCategories}
            styles={{
              placeholder: (base) => ({
                ...base,
                color: "#555",
              }),
            }}
          />
        </div>

        <div>
          <label htmlFor="inservices-add-instructors">Instructors</label>
          <FormSelect
            _key="id"
            _val="full_name"
            selectId={"inservices-add-instructors"}
            name="user_id"
            dataValue={instructors}
            options={defInstructors}
            urlSearch={this.employeeUrl()}
            selectProps={{ isMulti: true }}
            errors={errors.in_service_instructors}
            onChange={onChangeInstructors}
            styles={{
              placeholder: (base) => ({
                ...base,
                color: "#555",
              }),
            }}
          />
        </div>

        <div className="mb-15">
          <label>Status</label>
          <Select
            selectTitle={"select status"}
            selectProps={{ name: "status" }}
            options={[
              { id: "current", name: "Current" },
              { id: "future", name: "Future" },
              { id: "completed", name: "Completed" }
            ]}
            value={status}
            onChange={onChange}
          />
        </div>

        <div className="mb-15">
          <label>
            <input
              type="checkbox"
              style={{ width: "auto", marginRight: 6 }}
              checked={allowSignUps}
              onChange={onChangeAllowSignUps}
            />
            Allow employees to sign up for this in-service training?
          </label>
        </div>

        {allowSignUps ? (
          <div className="mb-15">
            <label>Class limit</label>
            <input
              className="form-control"
              name="classLimit"
              type="number"
              value={classLimit}
              onChange={onChange}
            />
          </div>
        ) : null}

        <div>
          <label htmlFor="inservices-add-notes">Notes</label>
          <textarea
            className="form-control"
            rows="5"
            name="notes"
            value={notes}
            onChange={onChange}
            id="inservices-add-notes"
          />
          <span className="dark-grey-text">
            **Bold** - *Italic* -
            [Link Title](https://digiquatics.com)
            * Bullets&nbsp;
            <a className="styled-link" target="_blank" href="https://help.digiquatics.com/product-questions/how-to-format-text-in-digiquatics-using-markdown">
              View Markdown tips
            </a>
          </span>
        </div>

        <div className="mb-15">
        <label id="add-inservices-attachment" className="control-label">Attachment</label>
          <Attachment
            files={generalFiles.filter(file => !file._destroy)}
            category="generalFiles"
            onDropFile={onAddAttachments}
            onDelete={onDeleteAttachment}
            labelId={"add-inservices-attachment"}
          />
        </div>

        <div>
          <label id="add-incervices-instructor-attachment" className="control-label">Instructor Attachments</label>
          <Attachment
            files={instructorsFiles.filter(file => !file._destroy)}
            category="instructorsFiles"
            onDropFile={onAddAttachments}
            onDelete={onDeleteAttachment}
            labelId={"add-incervices-instructor-attachment"}
          />
        </div>
      </div>
    );
  }
}

InServiceForm.propTypes = {
  errors: PropTypes.object.isRequired,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  categories: PropTypes.array.isRequired,
  instructors: PropTypes.array.isRequired,
  defInstructors: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  topic: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.any).isRequired,
  allowSignUps: PropTypes.bool.isRequired,
  classLimit: PropTypes.string.isRequired,
  notes: PropTypes.string.isRequired,
  generalFiles: PropTypes.array.isRequired,
  instructorsFiles: PropTypes.array.isRequired,
  status: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeInstructors: PropTypes.func.isRequired,
  onChangeCategories: PropTypes.func.isRequired,
  onChangeAllowSignUps: PropTypes.func.isRequired,
  onAddAttachments: PropTypes.func.isRequired,
  onDeleteAttachment: PropTypes.func.isRequired,
  toggleSaveDisabled: PropTypes.func.isRequired
};

export default InServiceForm;
